import { c as _c } from "react/compiler-runtime";
import { InputWithCustomValidationFeedback } from '@/components/Atoms/InputWithCustomValidationFeedback/InputWithCustomValidationFeedback';
import useTranslation from '@/hooks/useTranslation';
import type { IFormChoice, ISignupOptions } from '@/interfaces';
import type { ChangeEvent } from 'react';
import { useState } from 'react';
import type { FCl } from 'react-fc';
import styled from 'styled-components';
export const AccountPreferencesForm: FCl<IAccountPreferencesFormProps> = t0 => {
  const $ = _c(85);
  const {
    viewOnly,
    accountDetails,
    formOptions,
    className
  } = t0;
  const {
    t
  } = useTranslation("common");
  const {
    user
  } = accountDetails;
  const [selectedCountry, setCountry] = useState(user.country);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      setCountry(e.currentTarget.value);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleCountryChange = t1;
  let t2;
  if ($[1] !== t || $[2] !== user.firstName || $[3] !== user.lastName || $[4] !== viewOnly) {
    t2 = viewOnly ? <label>{t("Labels.name")}<input type="text" value={`${user.firstName} ${user.lastName}`} disabled={true} /></label> : <HalfLine><label>{t("Labels.first_name")}<InputWithCustomValidationFeedback type="text" name="firstName" required={true} maxLength={20} pattern="[ -~]{0,20}" defaultValue={user.firstName} disabled={viewOnly} customValidationFeedback={t("Feedback.input_unsupported_chars")} /></label><label>{t("Labels.last_name")}<InputWithCustomValidationFeedback type="text" name="lastName" required={true} maxLength={20} pattern="[ -~]{0,20}" defaultValue={user.lastName} disabled={viewOnly} customValidationFeedback={t("Feedback.input_unsupported_chars")} /></label></HalfLine>;
    $[1] = t;
    $[2] = user.firstName;
    $[3] = user.lastName;
    $[4] = viewOnly;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("Labels.email");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !user.isEnterprise || viewOnly;
  let t5;
  if ($[8] !== t4 || $[9] !== user.emailAddress) {
    t5 = <input type="email" name="emailAddress" required={true} defaultValue={user.emailAddress} readOnly={t4} />;
    $[8] = t4;
    $[9] = user.emailAddress;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <label data-target="details-email-address">{t3}{t5}</label>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("Labels.country");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = selectedCountry ?? "";
  let t9;
  if ($[16] !== t) {
    t9 = t("Forms.EditForm.select_box_disabled_default");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <option disabled={true} value="" hidden={true}>{" -- "}{t9}{" -- "}</option>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== formOptions.countryList) {
    t11 = formOptions.countryList.map(_temp);
    $[20] = formOptions.countryList;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t8 || $[25] !== viewOnly) {
    t12 = <select required={true} name="country" onChange={handleCountryChange} value={t8} disabled={viewOnly}>{t10}{t11}</select>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t8;
    $[25] = viewOnly;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t7) {
    t13 = <label data-target="details-country-selector">{t7}{t12}</label>;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== formOptions.countrySubDivisionList || $[31] !== selectedCountry || $[32] !== t || $[33] !== user.state || $[34] !== viewOnly) {
    t14 = selectedCountry && selectedCountry in formOptions.countrySubDivisionList && <label>{t("Labels.state")}<select required={true} name="state" defaultValue={user.state ?? ""} disabled={viewOnly}><option disabled={true} value="" hidden={true}>{" -- "}{t("Forms.EditForm.select_box_disabled_default")}{" -- "}</option>{formOptions.countrySubDivisionList[selectedCountry].map(_temp2)}</select></label>;
    $[30] = formOptions.countrySubDivisionList;
    $[31] = selectedCountry;
    $[32] = t;
    $[33] = user.state;
    $[34] = viewOnly;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14) {
    t15 = <HalfLine>{t13}{t14}</HalfLine>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t) {
    t16 = t("Labels.city");
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  const t17 = user.city ?? "";
  let t18;
  if ($[41] !== t) {
    t18 = t("Feedback.input_unsupported_chars");
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t17 || $[44] !== t18 || $[45] !== viewOnly) {
    t19 = <InputWithCustomValidationFeedback type="text" name="city" pattern={"\\D+"} maxLength={50} required={true} defaultValue={t17} disabled={viewOnly} customValidationFeedback={t18} />;
    $[43] = t17;
    $[44] = t18;
    $[45] = viewOnly;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t16 || $[48] !== t19) {
    t20 = <label data-target="details-city-input">{t16}{t19}</label>;
    $[47] = t16;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t) {
    t21 = t("Labels.role");
    $[50] = t;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  const t22 = user.role || "";
  let t23;
  if ($[52] !== t) {
    t23 = t("Forms.EditForm.select_box_disabled_default");
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t23) {
    t24 = <option disabled={true} value="" hidden={true}>{" -- "}{t23}{" -- "}</option>;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== formOptions.rolesList) {
    t25 = formOptions.rolesList.map(_temp3);
    $[56] = formOptions.rolesList;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t22 || $[59] !== t24 || $[60] !== t25 || $[61] !== viewOnly) {
    t26 = <select required={true} name="role" defaultValue={t22} disabled={viewOnly}>{t24}{t25}</select>;
    $[58] = t22;
    $[59] = t24;
    $[60] = t25;
    $[61] = viewOnly;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t21 || $[64] !== t26) {
    t27 = <label data-target="details-role-selector">{t21}{t26}</label>;
    $[63] = t21;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== t) {
    t28 = t("Labels.language");
    $[66] = t;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  const t29 = user.locale;
  let t30;
  if ($[68] !== formOptions.localesList) {
    t30 = formOptions.localesList.map(_temp4);
    $[68] = formOptions.localesList;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t30 || $[71] !== user.locale || $[72] !== viewOnly) {
    t31 = <select required={true} name="siteLocale" defaultValue={t29} disabled={viewOnly}>{t30}</select>;
    $[70] = t30;
    $[71] = user.locale;
    $[72] = viewOnly;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t28 || $[75] !== t31) {
    t32 = <label>{t28}{t31}</label>;
    $[74] = t28;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== className || $[78] !== t15 || $[79] !== t2 || $[80] !== t20 || $[81] !== t27 || $[82] !== t32 || $[83] !== t6) {
    t33 = <StyledFormContent className={className} data-sentry-mask={true}>{t2}{t6}{t15}{t20}{t27}{t32}</StyledFormContent>;
    $[77] = className;
    $[78] = t15;
    $[79] = t2;
    $[80] = t20;
    $[81] = t27;
    $[82] = t32;
    $[83] = t6;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  return t33;
};
const HalfLine = styled.div`
    display: flex;
    label {
        min-width: 50%;
        flex-grow: 1;
    }
`;
export const StyledFormContent = styled.div`
    label {
        margin-bottom: var(--size-grid-half);
        width: 100%;
        display: block;
    }
    input,
    select {
        display: block;
        margin-top: var(--size-grid-quarter);
    }
`;
export interface IAccountDetails {
  user: IAccountUser;
}
interface IAccountUser {
  firstName: string;
  lastName: string;
  locale: string;
  emailAddress?: string;
  country?: string;
  state?: string;
  city?: string;
  role?: string;
  isEnterprise: boolean;
  sailthruManageIframe: string;
}
interface IAccountPreferencesFormProps {
  viewOnly?: boolean;
  accountDetails: IAccountDetails;
  formOptions: ISignupOptions;
}
function _temp(x, i) {
  return <option value={x.value} key={i}>{x.label}</option>;
}
function _temp2(x_0, i_0) {
  return <option value={x_0.value} key={i_0}>{x_0.label}</option>;
}
function _temp3(x_1) {
  return <option value={x_1.label} key={x_1.label}>{x_1.label}</option>;
}
function _temp4(x_2) {
  return <option value={x_2.value} key={x_2.value}>{x_2.label}</option>;
}